export default "__VITE_ASSET__Tw4sSaI1__"